<div class="flexrow config-product-header" >
  <h2 class="config-title">{{ productname }}</h2>
  <h2 class="config-title">{{ parent_line.product_name}}</h2>
  <div mat-dialog-title>#&nbsp; {{ parent_line.product }}</div>
  <!-- <div mat-dialog-title>#&nbsp;{{ formgroup.controls.configuration_path.value }}</div> -->
</div>
@if (tree) {
  <mat-dialog-content class="flexcolumn" id="dialog-configurable-content">
    <ng-container [formGroup]="formgroup">
      <!-- <ng-container formArrayName="configuration"> -->
      <ng-container formGroupName="cufs">
        <ng-container [formArrayName]="C_CUF_CONFIGURATION_VALUE.toString()">
          <div class="tabletitle flexrow weight-500">
            <label class="title">Elément configurable</label>
            <section class="col2">Configuration commande</section>
            <section class="col3">Configuration préparation</section>
          </div>
          @for (node of configuration.controls; track node; let i = $index) {
            <div class="lines flexrow">
              <ng-container [formGroupName]="i">
                <label class="title">{{ node.get('name')?.value }}</label>
                <!-- <section class="col2"> -->
                <smart-select class="col2"
                  id="lnk_node_config_cmd_val_{{node.get('id_node')?.value }}"
                  formControlName="lnk_node_order_val"
                  [items]="getTreeFromPathWithNull($safeNavigationMigration(node.get('path')?.value), $safeNavigationMigration(node.get('nlevel')?.value) + 1)"
                  [bindLabelFn]="nullableNodeLabel"
                  placeholder="-"
                  (selectionChange)="onNodeOrderChange(node)">
                </smart-select>
              <!-- </section> -->
              <smart-select class="col2"
                id="lnk_node_config_product_line_{{node.get('id_node')?.value }}"
                formControlName="lnk_product"
                [items]="getProductsFromTreeNodeIdWithNull($safeNavigationMigration(node.get('lnk_node_order_val')?.value))"
                [bindLabelFn]="nullableNodeLabel"
                placeholder="-">
              </smart-select>
            </ng-container>
          </div>
        }
      </ng-container>
    </ng-container>
    <hr>
      <h4>Produits Associé</h4>
      @if (rootNode?.data) {
        <div class="config-sections">
          @for (section of rootNode!.data; track section.seq) {
            <div class="config-section">
              <h5>{{ section.label }}</h5>
              <div class="config-section-products">
                @for (prod of section.products; track prod.id) {
                  @let fullProd = getProductInfo(prod.id);
                  @if (fullProd) {
                    <div class="config-product-item">
                      <input type="checkbox"
                        [id]="'prod_' + prod.id"
                        [checked]="isSectionProductSelected(prod.id)"
                        (change)="toggleSectionProduct(prod.id)">
                      <label [for]="'prod_' + prod.id">{{ fullProd.name }}</label>
                      @if (prod.price_discounted_taxx ?? fullProd.price_discounted_taxx) {
                        <span>{{ prod.price_discounted_taxx ?? fullProd.price_discounted_taxx }} €</span>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      }
    </ng-container>
    <br />
    <br />
    <hr />
    <h4>data récupérer a l'ouverture de la modal</h4>
    <div>
      {{ dialogData | json }}
    </div>
    <h4>Complete tree</h4>
    @for (node of tree; track node) {
      <div>
        {{ node | json }}
      </div>
    }
    <hr />
    <h4>Components</h4>
    @for (node of components; track node) {
      <div>
        {{ node | json }}
      </div>
    }
    <br />
    <hr />
    <h4>Stored values</h4>
    <div>
      {{ dialogData.values | json}}
    </div>
    <br />
    <hr />
    <h4>Input values</h4>
    <div>
      <!-- {{ formgroup.controls.configuration.value | json}} -->
    </div>
  </mat-dialog-content>
}
<mat-dialog-actions>
  <!-- <button mat-button (click)="onCancel()">Annuler</button> -->
  <button id="validation_config_product_modal" mat-button (click)="onOk()">Ok</button>
</mat-dialog-actions>